import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { branchStore } from '../../../mobx/branchStore';
import BranchSearchBox from './components/BranchSearchBox/BranchSearchBox';
import MapDeliveryBranch from './components/MapDeliveryBranch/MapDeliveryBranch';
import DeliveryTypeMap from './containers/DeliveryTypeMap/DeliveryTypeMap';
import DeliveryTypeSidebar from './containers/DeliveryTypeSidebar/DeliveryTypeSidebar';
import { deliveryTypeStore } from './store/deliveryTypeStore';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { modalStore } from 'src/mobx/modalStore';
import CustomModalComponent from 'src/view/components/Controls/Modal/Modal';
import ModalBackground from 'src/view/components/Controls/Modal/ModalBackground/ModalBackground';

const DeliveryTypeScreen: React.FC = observer((): JSX.Element => {
  useEffect(() => {
    if (modalStore.deliveryType) {
      deliveryTypeStore.init(modalStore.deliveryType);
    }
  }, []);

  return (
    <CustomModalComponent
      onRequestClose={modalStore.closeDeliveryType}
      className="delivery-type-screen animate__faster animate__animated animate__fadeInUp"
      isOpen
    >
      <ModalBackground>
        <div className="d-flex flex-1 full-height">
          <DeliveryTypeMap />
          <DeliveryTypeSidebar />
        </div>
        {deliveryTypeStore.deliveryType === DELIVERY_TYPE.DELIVERY ? (
          <>
            <MapDeliveryBranch />
            <BranchSearchBox />
          </>
        ) : null}
      </ModalBackground>
    </CustomModalComponent>
  );
});

export default DeliveryTypeScreen;
